module.exports = __webpack_public_path__ + "static/media/143.ef3e7cff.svg";